import AppIcon from "./AppIcon";
export default function CloseButton({ onClick }) {
  return (
    <button type="button" className="rounded-sm bg-card text-muted-fg hover:text-primary" onClick={onClick}>
      <AppIcon code="fa-x" className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
